"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var pass_exports = {};
__export(pass_exports, {
  boundsRulePasses: () => boundsRulePasses,
  customRulePasses: () => customRulePasses,
  requiredRulePasses: () => requiredRulePasses,
  timestampBoundsRulePasses: () => timestampBoundsRulePasses
});
module.exports = __toCommonJS(pass_exports);
var import_guard = require("@cartographerio/guard");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_run = require("../expr/run.js");
function requiredRulePasses(fieldType, value) {
  switch (fieldType) {
    case "TextField":
    case "TextArea":
    case "Autocomplete":
      return (0, import_guard.isString)(value) ? value !== "" : value != null;
    case "IntegerField":
    case "NumberField":
    case "UserRefField":
    case "TimestampField":
    case "LineStringField":
    case "PolygonField":
    case "PointField":
    case "TeamField":
    case "FeatureField":
    case "NearestFeatureField":
    case "Select":
      return value != null;
    case "MultiSelect":
      return (0, import_guard.isArray)(value) ? value.length > 0 : value !== null;
    default:
      return (0, import_util.checkExhausted)(fieldType);
  }
}
function customRulePasses(expr, env) {
  return (0, import_run.topoEval)(expr, env);
}
function optCompare(value, comparator, orElse = true) {
  return value == null ? orElse : comparator(value);
}
function boundsRulePasses(minValue, maxValue, value) {
  return value == null || optCompare(minValue, (minValue2) => value >= minValue2) && optCompare(maxValue, (maxValue2) => value <= maxValue2);
}
function timestampBoundsRulePasses(minValue, maxValue, value, validateTime, now = (0, import_types.nowTimestamp)()) {
  const tsValue = (raw) => (0, import_types.formatTimestamp)(raw === "now" ? now : raw, {
    format: validateTime ? import_types.iso8601TimestampFormat : import_types.yyyymmdd,
    timeZone: import_types.utc
  });
  return value == null || optCompare(minValue, (minValue2) => tsValue(value) >= tsValue(minValue2)) && optCompare(maxValue, (maxValue2) => tsValue(value) <= tsValue(maxValue2));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  boundsRulePasses,
  customRulePasses,
  requiredRulePasses,
  timestampBoundsRulePasses
});
//# sourceMappingURL=pass.js.map
